var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 9.58334V4.83334C14.1666 3.43321 14.1666 2.73315 13.8941 2.19837C13.6544 1.72796 13.272 1.34551 12.8016 1.10583C12.2668 0.833344 11.5667 0.833344 10.1666 0.833344H4.83325C3.43312 0.833344 2.73306 0.833344 2.19828 1.10583C1.72787 1.34551 1.34542 1.72796 1.10574 2.19837C0.833252 2.73315 0.833252 3.43321 0.833252 4.83334V13.5C0.833252 14.9001 0.833252 15.6002 1.10574 16.135C1.34542 16.6054 1.72787 16.9878 2.19828 17.2275C2.73306 17.5 3.43308 17.5 4.83313 17.5H7.91659M9.16659 8.33334H4.16659M5.83325 11.6667H4.16659M10.8333 5.00001H4.16659M9.99992 15L12.4999 17.5M12.4999 17.5L14.9999 15M12.4999 17.5V12.5",
    stroke: "#414651",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b5b4f249fd6b818e2da59a2096fe115e.svg";
export { ForwardRef as ReactComponent };